import cn from 'classnames'
import { Fragment, ReactNode, useMemo } from 'react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import { PaginationOptions } from 'swiper/types'

import { chunkArray } from '@shared'

import { webApp } from '../webApp'
import styles from './CardSlider.module.scss'
import { CARD_SLIDER_GROUP_SIZE } from './constants'
import { CardSliderFooterBorderIcon, CardSliderFooterWingsIcon } from './icons'

const hapticFeedback = webApp?.HapticFeedback

type Props = {
  header?: ReactNode
  cards: ReactNode[]
  className?: string
  dynamicBullets?: boolean
  swiperClassName?: string
  onSlideChange?: SwiperProps['onSlideChange']
  withoutFooter?: boolean
}

export const CardSlider = ({
  header,
  cards,
  className,
  swiperClassName,
  dynamicBullets = true,
  onSlideChange,
  withoutFooter,
}: Props) => {
  const groupedCards = useMemo(() => {
    return chunkArray(cards, CARD_SLIDER_GROUP_SIZE)
  }, [cards])

  const pagination: PaginationOptions = {
    clickable: true,
    dynamicBullets,
    renderBullet: (_, className) => {
      return `<span class="${styles.paginationBullet} ${className}"></span>`
    },
  }
  return (
    <div className={cn(styles.container, className)}>
      {header}
      <Swiper
        grabCursor
        centeredSlides
        loop
        slidesPerView="auto"
        onTouchStart={() => hapticFeedback?.impactOccurred('medium')}
        onSlideChange={onSlideChange}
        watchSlidesProgress
        pagination={pagination}
        className={cn(styles.swiper, swiperClassName)}
        modules={[Pagination]}
      >
        {groupedCards.map((group, index) => (
          <SwiperSlide key={index} className={styles.slide}>
            {group.map((card, index) => (
              <Fragment key={index}>{card}</Fragment>
            ))}
          </SwiperSlide>
        ))}
      </Swiper>
      {!withoutFooter && (
        <div className={styles.footer}>
          <CardSliderFooterBorderIcon />
          <CardSliderFooterWingsIcon
            className={cn(styles.wing, styles.wing__right)}
          />
          <CardSliderFooterWingsIcon
            className={cn(styles.wing, styles.wing__left)}
          />
        </div>
      )}
    </div>
  )
}
